import { useContext } from 'react';
import { RouteComponentProps, __RouterContext } from 'react-router';



export default function useRouter(): RouteComponentProps {
    return useContext(__RouterContext);
}
